import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { checkOptinAvailabilityRpc, updateTargetStateRpc } from '../../__generated__/chirp/com/hubspot/optins/rpc/OptinsAvailabilityRpc';
export const fetchOptin = (optinName, httpClient = http) => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: httpClient
  });
  return rpcClient.call(checkOptinAvailabilityRpc, {
    request: {
      optinName
    }
  }).then(({
    availability
  }) => ({
    actionsAllowed: availability.actionsAllowed,
    optedIn: availability.state === 'OPTED_IN',
    optinId: availability.optinId,
    optinName: availability.optinName,
    stateActionAt: availability.stateActionAt
  }));
};
export const updateOptin = (optinName, newState, currentActionAt, httpClient = http) => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: httpClient
  });
  return rpcClient.call(updateTargetStateRpc, {
    request: {
      optinName,
      newState,
      currentActionAt
    }
  });
};